import React from 'react';
import styled from 'styled-components/macro';
import { Section, Paragraph } from '../Typography';

const TermsOfServiceText = () => {
  const privacyStatementUrl = `${process.env.REACT_APP_URL}form?privacyStatement=true`;
  return (
    <Section>
      <Paragraph>Created on the 2nd June 2020</Paragraph>
      <Paragraph>
        By using or accessing the boost.ai’s conversational AI platform, admin
        panel, e-learning platform and its related products, services, software,
        backends, demo presentations, videos, audio, graphics, photos, text,
        branding (including trade names, trademarks, service marks, or logos),
        interactive features, functionalities, metrics, and/or any other
        materials provided by Boost AI AS, Boost AI Inc and its affiliates
        (“boost.ai”) (collectively, the “Services'') you manifest your
        unconditional acceptance of these Terms of Service (“Tos”), including
        the policies referenced in these ToS, unless otherwise agreed in writing
        by a separate binding agreement between you and an authorized legal
        representative of boost.ai.
      </Paragraph>
      <Paragraph>
        The Services are not available to persons who are not legally eligible
        to be bound by these ToS. Throughout these ToS, “you” or “your” refers
        to you as the user accessing or using any of the Services, or if you are
        using the Services on behalf of an entity such as your employer, “you”
        or “yours” refers to that entity. You represent and warrant that you
        have the legal right and capacity to enter into these ToS in your
        jurisdiction, and if you are using the Services on behalf of an entity,
        you represent and warrant that you are authorized to agree to these ToS
        on the entity’s behalf.{' '}
        <strong>Please review these ToS thoroughly before accepting it.</strong>
      </Paragraph>
      <Paragraph>
        <strong>
          Boost.ai is not liable or responsible for any results generated
          through your access or use of the Services, including but not limited
          to any damage, loss of profits, revenues, business opportunities,
          goodwill, or anticipated savings; loss or corruption of data; indirect
          or consequential loss and/or punitive damages. Other than as expressly
          stated in these ToS or as required by law, the Services are provided
          “as is” and boost.ai does not make any specific commitments or
          warranties about the Services, including its quality, accuracy,
          reliability, availability, or ability to meet your needs.
        </strong>
      </Paragraph>
      <Paragraph>
        <strong>
          Your use of the Services does not grant you ownership to any aspect of
          the Services which remain of sole ownership of boost.ai.
        </strong>
      </Paragraph>
      <Paragraph>
        You confirm that you are not a Competitor and you will not allow
        Competitors or its affiliates to access the Services unless explicitly
        approved in writing by a legal representative of boost.ai. For the sake
        of clarity, Competitors are considered any third party who provides
        chatbot or virtual assistant related software and/or service.
      </Paragraph>
      <Paragraph>
        You are not entitled to, and shall not permit anyone to, circumvent the
        technical limitations of the Services, reverse engineer, decompile or
        disassemble the Services or otherwise attempt to derive the source code
        of the software used to provide the Services, produce copies of the
        Services, publish the Services so that others may copy, distribute,
        rent, lease or lend the Services or grant access to the Services, or
        access the Services or use the related documentation in order to build a
        similar or competitive product.
      </Paragraph>
      <Paragraph>
        You may not change or remove markings or notices relating to
        intellectual property rights, patents, trademarks, or other rights
        placed in the Services.
      </Paragraph>
      <Paragraph>
        You will keep all boost.ai’s Confidential information, in the strictest
        confidence. You shall not disclose, reproduce or use boost.ai’s
        Confidential information except as expressly permitted in writing by
        boost.ai. ‘Confidential information’ means all information that you may
        gain access to through using or accessing the Services. Confidential
        information includes, without limitation and in whatever format,
        information relating to boost.ai’s software, source code, application
        programming interface (API) data files, documentation, specifications,
        databases, networks, system design, file restricted layouts, tool
        combinations, development methods, consulting methodologies, user
        manuals and documentation, training materials, schema, flow charts, and
        prototypes.
      </Paragraph>
      <Paragraph>
        Your obligation to maintain the confidentiality and security of
        confidential information remains, even after your access to the Services
        ends and shall continue for as long as such confidential information is
        not made public by means other than the breach of this agreement.
      </Paragraph>
      <Paragraph>
        Any misappropriation of any of the confidential information in violation
        of this agreement may cause the Company irreparable harm, the amount of
        which may be difficult to ascertain, and therefore you agree that the
        company shall have the right to apply to a court of competent
        jurisdiction for an order enjoining any such further misappropriation
        and for any other relief as the company deems appropriate. This right is
        to be in addition to the remedies otherwise available to the company.
      </Paragraph>
      <Paragraph>
        To the extent permitted by applicable law, you agree to defend,
        indemnify and hold harmless boost.ai, its officers, directors,
        employees, and agents, from and against any and all claims, damages,
        obligations, losses, liabilities, costs or debt, and expenses (including
        but not limited to attorney's fees) arising from (i) your use of and
        access to the Services; (ii) violation of any term of these ToS; (iii)
        violation of any third party right, including without limitation any
        copyright, property, or privacy right.
      </Paragraph>
      <Paragraph>
        You have the temporary and revocable right to access the Services as
        made available to you, as long as you comply with these ToS and the
        applicable law.
      </Paragraph>
      <Paragraph>
        You agree that boost.ai, in its sole discretion, may immediately
        terminate your access to the Services at any time, for any reason. Upon
        termination or expiration of your access to the Services, you will no
        longer be able to access or retrieve any data through the Services.
      </Paragraph>
      <Paragraph>
        In order to provide you with the Services, we may collect personal data.
        Our{' '}
        <PrivacyLink href={privacyStatementUrl} targer="_blank">
          Privacy Policy
        </PrivacyLink>{' '}
        explains how we treat your personal data and protect your privacy when
        you use the Services.
      </Paragraph>
      <Paragraph>
        We are constantly trying to improve our Services, so these ToS may need
        to change along with the Services. We reserve the right to change the
        ToS at any time. Your continued use of the Services will be deemed as
        acceptance of any updates to the ToS.
      </Paragraph>
      <Paragraph>
        The availability of the portal outside of Norway does not imply any
        representation that the Services are appropriate or available for use in
        such locations.
      </Paragraph>
      <Paragraph>
        In the event that any provision of these ToS are deemed invalid or
        unenforceable, the remainder of these ToS shall not in any way be
        affected or impared thereby.
      </Paragraph>
      <Paragraph>
        Any and all disputes arising out of the rights and obligations in these
        ToS shall be submitted to ordinary court proceedings. The Parties accept
        the Stavanger City Court as their exclusive legal venue under this
        agreement. These ToS shall be governed by and interpreted in accordance
        with the laws of Norway.
      </Paragraph>
    </Section>
  );
};

const PrivacyLink = styled.a`
  #certiself-form & {
    text-decoration: underline;
    color: #552a55;
  }
`;

export default TermsOfServiceText;
